import 'firebase/remote-config';
import 'firebase/analytics';
import firebase from './firebase_config';

export const defaultPriceList = [
        {"engine":"Stockfish","server":150000000,"price":20},
        {"engine":"Stockfish","server":350000000,"price":60},
        {"engine":"Stockfish","server":500000000,"price":80},
        {"engine":"LCZero","server":100000,"price":10},
        {"engine":"SugaR","server":75000000,"price":10},
        {"engine":"asmFish","server":75000000,"price":10}
     ];

const remoteConfig = firebase.remoteConfig();
remoteConfig.settings = {
   minimumFetchIntervalMillis: 3600000,
};
remoteConfig.defaultConfig = ({
  'priceList': JSON.stringify({  "prices": defaultPriceList})
});


function getConfigs(config, cb){
    var response = remoteConfig.getValue(config);
    cb(JSON.parse(response._value));
}

export function getRemoteConfigs (config, cb) {
     remoteConfig.fetchAndActivate()
      .then(() => {
        getConfigs(config, cb);
      })
      .catch((err) => {
        console.error(err);
      });
}

const analytics = firebase.analytics();

// eslint-disable-next-line import/prefer-default-export
export function signUpPageView() {
  analytics.logEvent('sign_up', { 'method': 'email' });
}
